<template>
    <div class="container">
        <SignInPC v-if="isPC" />
        <SignInH5 v-else/>
    </div>
</template>
<script>
    import { enableAppShare } from '../../../common/js/APP/share';
    import SignInH5 from '../components/SignInH5';
    import SignInPC from '../components/SignInPC';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC,
        },
        data() {
            return {
                isBView:'A',//A版 false     B版 true
            };
        },
        created () {
            enableAppShare({
                title: '速来直播间，领取福利！',
                desc: '名企专家在线答疑，求职问题一站搞定！',
                imgUrl: 'https://s20.lgstatic.com/growth/activity/20220215/1644912610561.png'
            });
        },
        methods: {

        },
    };
</script>
<style>
html, body, .container {
    height: 100%;
}
</style>